import React from 'react';

export const path =
  'M9,5 L12.5,5 C12.7761424,5 13,5.22385763 13,5.5 L13,8.5 C13,8.77614237 12.7761424,9 12.5,9 L9,9 L9,12.5 C9,12.7761424 8.77614237,13 8.5,13 L5.5,13 C5.22385763,13 5,12.7761424 5,12.5 L5,9 L1.5,9 C1.22385763,9 1,8.77614237 1,8.5 L1,5.5 C1,5.22385763 1.22385763,5 1.5,5 L5,5 L5,1.5 C5,1.22385763 5.22385763,1 5.5,1 L8.5,1 C8.77614237,1 9,1.22385763 9,1.5 L9,5 Z';

export default class Ajax extends React.PureComponent {
  render() {
    return (
      <g>
        <rect width="14" height="14" opacity="0" />
        <rect
          width="12"
          height="4"
          x="1"
          y="5"
          fill="#D8D8D8"
          rx=".5"
          className="fill-current"
        />
      </g>
    );
  }
}
